import React from 'react'
import './index.less'

const clsPrefix = 'c-update-item'
const UpdateItem: React.FC<{
  imgUrl?: string,
  title?: string,
  publicTime?: string,
  description?: string
}> = ({
  imgUrl = '',
  title = '',
  publicTime = '',
  description = ''
}) => {
  return (
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__thumb`}>
        <img src={imgUrl} className='thumb-image' />
      </div>
      <div className={`${clsPrefix}__content`}>
        <p className={`${clsPrefix}__content-title`}>{title}</p>
        <p className={`${clsPrefix}__content-public-time`}>{`发布于${publicTime}`}</p>
        <p className={`${clsPrefix}__content-description`}>{description}</p>
      </div>
    </div>
  )
}

export { UpdateItem }
